import { render, staticRenderFns } from "./SOCPilot.vue?vue&type=template&id=5e178c4e&scoped=true&"
import script from "./SOCPilot.vue?vue&type=script&lang=js&"
export * from "./SOCPilot.vue?vue&type=script&lang=js&"
import style0 from "./SOCPilot.vue?vue&type=style&index=0&id=5e178c4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e178c4e",
  null
  
)

export default component.exports